import React, { useEffect, ReactNode } from "react";
import HeaderAdmin from "./HeaderAdmin";
import FooterAdmin from "./FooterAdmin";

type HeadProps = { title: string };
type LayoutProps = { children?: ReactNode; title?: string };

const Head: React.FC<HeadProps> = ({ title }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
};

const AdminLayout = ({ children, title = "" }: LayoutProps) => (
  <>
    <Head title={title} />
    <>
      <HeaderAdmin />

      <main className="mt-[53px] xl:mt-[58px]">{children}</main>

      <FooterAdmin />
    </>
  </>
);

export default AdminLayout;
